export function initialState() {
  return {
    players: [],
    ConvocatedPlayersBasedonRole: [],
    matchId: null,
    formations: [],
    match: null,
    homeMatchPlayersNumber: 11,
    opponentMatchPlayersNumber: 11,
    editorDialog: false,
    form: {
      type: 0,
      duration: 90,
      players: 11,
      opponentName: '',
      playedAt: '',
      home: true,
      scuolaCalcio: false,
      day: null,
      notes: '',
      kicks: [],
      homePlayers: {},
      opponentPlayers: {},
      homeModule: {
        teamFormation: null,
        players: {},
        canvas: null,
        canvasImage: null,
      },
      homeModule2: {
        teamFormation: null,
        players: {},
        canvas: null,
        canvasImage: null,
      },
      opponentModule: {
        teamFormation: null,
        players: {},
        canvas: null,
        canvasImage: null,
      },
      homeGoals: [],
      opponentGoals: [],
      homeSubstitutions: [],
      opponentSubstitutions: [],
      homeAdmonitions: [],
      opponentAdmonitions: [],
      homeExpulsions: [],
      opponentExpulsions: [],
      convocationPlace: null,
      convocations: {},
      distinctInfos: {
        championship: null,
        place: null,
        captainId: null,
        viceId: null,
        assistant: null,
        manager: null,
        manager2: null,
        doctor: null,
        coach: null,
        coach2: null,
        massagist: null,
        notes: null,
        company: null,
      },
    },
    errors: {
      form: null,
    },
  };
}

export default {
  ...initialState(),
  pagination: {
    rowsPerPage: 25,
    sortBy: 'played_at',
    descending: true,
  },
};



// WEBPACK FOOTER //
// ./src/store/matches/state.js